export const randomInt = (min, max) => Math.floor(Math.random()*(max-min+1)+min);

export const bytesToSize = (bytes) => {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    if ( bytes > 1000000000000 )
        return (bytes / 1000000000000).toFixed(2) + " " + sizes[4];
    else if ( bytes > 1000000000 )
        return (bytes / 1000000000).toFixed(2) + " " + sizes[3];
    else if (bytes > 1000000)
        return (bytes / 1000000).toFixed(0) + " " + sizes[2];
    else if (bytes > 1000)
        return (bytes / 1000).toFixed(0) + " " + sizes[1];
    else
        return bytes + " " + sizes[0]
};

export const setCookie = (name, value, exhours) => {
    var expires = "";
    if (exhours) {
        var date = new Date();
        date.setTime(date.getTime() + (exhours *60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/;" + " Secure;";
    return true;
};

export const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    return cookies;
};

// Clear all local storage items except the items we need to persist
export const clearLocalStorage = () => {

    let persist = [
        'persistent_profile_mode',
        'report_delta',
        'collapseUsage',
        'collapseUser',
        'collapseAgents',
        'joined_kasms',
        'login_logo',
        'login_caption',
        'header_logo',
        'login_splash_background',
        'splash_background',
        'launcher_background_url',
        'html_title',
        'favicon_logo',
        'default_keyboard_controls_mode',
        'ime_mode',
        'themecolor',
        'openTabIn',
        'kasm_prefer_local_cursor',
        'kasm_resize_mode',
        'kasm_video_quality',
        'kasm_enable_perf_stats',
        'kasm_frame_rate',
        'kasm_forced_resolution_width',
        'kasm_forced_resolution_height',
    ];

    let cached_values = {};

    for (let i = 0; i < persist.length; i++) {
        let t = window.localStorage.getItem(persist[i]);
        if (t) {
            cached_values[persist[i]] = t;
        }
    }

    window.localStorage.clear();

    for (var x in cached_values){
        window.localStorage.setItem(x, cached_values[x]);
    }


};

export const fuzzySearch = (filter, row) =>  {
    // Some values are null so we cast them to an empty string
    let id =  row[filter.id];
    if (id === undefined || id === null){
        id = '';
    }
    id = id.toString().toLowerCase();
    return id.includes(filter.value.toLowerCase())
};



const setLight =()=> {
    localStorage.setItem("theme", "Light");
    document.body.classList.add("light");
    // document.documentElement.setAttribute("data-theme", "light");
};
    // Set dark theme
const setDark =()=> {
    localStorage.setItem("theme", "Dark");
    document.body.classList.add("dark", "tw-dark");
};
    // Set auto browser default
const setAutoBrowserDefault =()=> {
    const currentColorScheme = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (currentColorScheme) {
        localStorage.setItem("theme", "Dark");
        document.body.classList.add("dark", "tw-dark");
    } else {
        localStorage.setItem("theme", "Light");
        document.body.classList.add("light");
    }
};


export const setThemeColor = (themeColor) => {
    // removing custom theme color related classes from body
    document.body.classList.remove("light","dark","tw-dark");

    // Start :: for selected color active
    localStorage.setItem("themecolor", themeColor);
    // End :: for selected color active

    if (themeColor === 'Light') {
        setLight();
    } else if (themeColor === 'Dark') {
        setDark();
    } else {
        setAutoBrowserDefault();
    }

    // Start :: remove and add active class
    let allElements = document.querySelectorAll(".theme-color-buttons");
    for(let i=0; i < allElements.length; i++) {
        allElements[i].classList.remove("active");
    }
}